import { cx } from '@vizit/theme';

interface CardFooterProps extends React.HTMLAttributes<HTMLDivElement> {}

function CardFooter(props: CardFooterProps) {
  const { children, className, ...rest } = props;

  return (
    <div className={cx('w-full py-8 px-10 flex justify-end border-t border-secondary', className)} {...rest}>
      {children}
    </div>
  );
}

export { CardFooter };
